import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { RequestBonusAssignmentRequest } from '../models/requestBonusAssignmentRequest';
import { deleteBonusAssignments, getAllBonusAssignments } from '../Api/bonusApi';

export const useManageBonus = (params: RequestBonusAssignmentRequest) => {
    const queryClient = useQueryClient();

    const { data: bonusAssignments = [], isLoading, error, refetch } = useQuery({
        queryKey: ['bonusAssignments', params],
        queryFn: () => getAllBonusAssignments(params),
        enabled: params.employeeIds.length > 0,
    });

    const deleteMutation = useMutation({
        mutationFn: (ids: number[]) => deleteBonusAssignments(ids),
        onSuccess: () => {
            toast.success('Bonificaciones eliminadas exitosamente');
            queryClient.invalidateQueries({ queryKey: ['bonusAssignments'] });
        },
        onError: (error: any) => {
            toast.error(error?.response?.data || 'Error al eliminar bonificaciones');
        },
    });

    return {
        bonusAssignments,
        isLoading,
        error,
        refetch,
        deleteBonusAssignments: deleteMutation.mutate,
        isDeleting: deleteMutation.isPending,
    };
};